import styled from 'styled-components';

export const Description = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  margin: 0;
  padding: 0;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
`;

export const PathValue = styled.span`
  color: ${({ theme }) => theme.palette.text.primary};
`;
